import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  CenterFeatureContainer,
  StyleLeftWrapper,
  StyleLogoWrapper,
} from "scmp-app/components/header/styles";

export const getStyleLayout = ({
  config,
  features,
  initEdition,
  shouldSwap,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <CenterFeatureContainer>
      {features.oneLineMenu({
        appBarVariant: config?.appBarVariant,
        initEdition,
        showIn: "desktopUp",
      })}
      <StyleLogoWrapper>
        {features.styleLogoLink({
          shouldSwap,
          showIn: "mobileAndTablet",
          showOnSwap: true,
        })}
        {features.styleTextLink({
          shouldSwap,
          showIn: "mobileAndTablet",
          showOnSwap: true,
        })}
      </StyleLogoWrapper>
    </CenterFeatureContainer>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      <StyleLeftWrapper>
        {features.styleLogoLink({ showIn: "desktopUp" })}
        {features.styleTextLink({ showIn: "desktopUp" })}
        {features.search({
          showDesktopDivider: true,
          showIn: "mobileUp",
        })}
      </StyleLeftWrapper>
    </>
  ),
  right: (
    <>
      {features.myNews({
        shouldSwap,
        showIn: "mobileUp",
        showOnSwap: "mobile",
      })}
      {features.dashboard({
        hideOnSwap: "mobile",
        shouldSwap,
        showIn: "mobileUp",
      })}
    </>
  ),
});
